// import LiveChat from "./LiveChat.js";

const Scripts = {
    loadScripts(user) {
        // Load training script
        if (!document.getElementById("aa-training-root-script")) {
            var trainingScript = document.createElement("script");
            trainingScript.id = "aa-training-root-script";
            trainingScript.type = "text/javascript";
            trainingScript.language = "javascript";
            trainingScript.async = true;
            trainingScript.src = "https://cdn.whatfix.com/prod/b3d0c6ab-8f0e-4f4d-988a-b4c0374428e0/initiator/initiator.nocache.js";
            var bodyElements = document.getElementsByTagName("body");
            if (bodyElements && bodyElements.length > 0) bodyElements[0].appendChild(trainingScript);
        }

        // Load analytics script
        if (!document.getElementById("aa-google-analytics-script")) {
            var analyticsScript = document.createElement("script");
            analyticsScript.id = "aa-google-analytics-script";
            analyticsScript.type = "text/javascript";
            analyticsScript.language = "javascript";
            analyticsScript.async = true;
            analyticsScript.src = "https://www.googletagmanager.com/gtag/js?id=G-SX66BF6T4C";
            analyticsScript.onload = function () {
                // console.log("Google Analytics script loaded");
                window.dataLayer = window.dataLayer || [];

                function gtag() {
                    dataLayer.push(arguments);
                }

                gtag('js', new Date());
                gtag('config', 'G-SX66BF6T4C');
            }

            var bodyElements = document.getElementsByTagName("body");
            if (bodyElements && bodyElements.length > 0) bodyElements[0].appendChild(analyticsScript);
        }

        // LiveChat.loadPlugin();
    }
}

export default Scripts;


// WEBPACK FOOTER //
// ./src/lib/others/Scripts.js